import { useEffect, useState } from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import PublicAPI from '@/api/TreedisPublicDAO';
import { useRecoilValue, translationDataState, tourConfigsState } from '../../../store';

export const CustomSelectWrap = styled.div`
  justify-content: space-between;
  align-items: center;
  display: flex;
  padding: 0 5px;
  line-height: 1.1;
  font-size: 15px;

  @media screen and (max-width: 760px) {
    width: 33.33%;
    font-size: 13px;
  }
`;

export const CustomSelect = styled.div<{ rtl?: boolean }>`
  background: transparent;
  color: white;
  text-transform: uppercase;
  position: relative;
  margin: 0 5px;

  div.mainItem {
    cursor: pointer;
  }

  div.optionItem {
    line-height: 1.3;
    background: transparent;
    cursor: pointer;

    display: flex;
    color: white;
    align-items: center;
    justify-content: start;
    margin-bottom: 10px;

    i {
      font-size: 5px;
      margin: 5px;
      text-decoration: initial !important;
    }

    span {
      display: block !important;
    }

    &.active {
      text-decoration: underline;
    }
  }

  div.optionsWrap {
    position: absolute;
    //padding: 16px 0 11px 27px;
    background-color: rgba(44, 44, 44, 0.9);
    border-radius: 12px;
    //margin-left: -40px;
    width: calc(100% + 51px);

    //padding: 20px 3px 10px 10px;
    padding: 10px 3px 5px 10px;
    ${({ rtl }) =>
      `${rtl ? 'padding: 10px 10px 5px 3px;right: 0;left: initial;right: -20px;' : ''}`};

    left: 0;
    margin-left: 0;
    margin-top: 21px;
  }

  @media screen and (max-width: 760px) {
    div.optionsWrap {
      margin-top: 9px;
      width: 100vw;
      position: absolute;
      left: -20px;
    }
  }
`;

const TourLanguageSelect = (props: { tourId: number }) => {
  const { tourId } = props;
  const {
    current_tour_has_no_language = 'Current tour has no language',
    no_language = 'no language',
  } = useRecoilValue(translationDataState);
  const [duplicates, setDuplicates] = useState<any>(null);
  const [duplicatesIsOpen, setDuplicatesIsOpen] = useState(false);

  useEffect(() => {
    (async () => {
      const initialDuplicatesRes = await PublicAPI.getDuplicates(tourId);
      if (initialDuplicatesRes && initialDuplicatesRes.message.includes('Success')) {
        setDuplicates(initialDuplicatesRes.duplicates);
      }
    })();
  }, []);

  const getCurrentLanguage = () => {
    const pathnameSplitted = window.location.pathname.split('/');
    return (duplicates || []).find((duplicate: any) => pathnameSplitted.includes(duplicate.slug));
  };

  const isLanguageActive = (slug: string) => {
    const pathnameSplitted = window.location.pathname.split('/');
    return pathnameSplitted.find((p: string) => p === slug);
  };

  const handleLanguageClick = (slug: string) => () => {
    if (!isLanguageActive(slug)) {
      replaceSlug(slug);
      setDuplicatesIsOpen(false);
    }
  };

  const replaceSlug = (slug: string) => {
    const pathnames = window.location.pathname.split('/');
    pathnames.shift();
    const targetLink = `/${pathnames[0]}/${pathnames[0] === 'experience' ? pathnames[1] : slug}${pathnames[0] === 'experience' ? `/${slug}` : ''}`;
    location.replace(window.location.origin + targetLink);
  };

  const currentLanguageObj = getCurrentLanguage();
  const { rtl } = useRecoilValue(tourConfigsState);

  return duplicates && duplicates.length > 1 ? (
    <CustomSelectWrap>
      <i className="far fa-globe" />
      <CustomSelect rtl={rtl}>
        <div className="mainItem" onClick={() => setDuplicatesIsOpen(!duplicatesIsOpen)}>
          {currentLanguageObj?.language ||
            currentLanguageObj?.languageEn ||
            current_tour_has_no_language}
        </div>
        {duplicatesIsOpen && (
          <div className="optionsWrap">
            {duplicates.map((duplicate, num) => (
              <div
                className={cn('optionItem', isLanguageActive(duplicate.slug) && 'active')}
                key={num}
                onClick={handleLanguageClick(duplicate.slug)}
              >
                <i className="fas fa-circle" />
                <span>
                  {duplicate?.language ||
                    duplicate?.languageEn ||
                    `${no_language} / ${duplicate.slug}`}
                </span>
              </div>
            ))}
          </div>
        )}
      </CustomSelect>
      {duplicatesIsOpen ? (
        <i className="fas fa-chevron-up" />
      ) : (
        <i className="fas fa-chevron-down" />
      )}
    </CustomSelectWrap>
  ) : null;
};

export default TourLanguageSelect;
